// extracted by mini-css-extract-plugin
export default {"body":"input_body__pD4Nb","inputBox":"input_inputBox__2H+Ak","inputOptionsList":"input_inputOptionsList__x9fus","inputOption":"input_inputOption__k3gxQ"};